import { computed, ref } from 'vue'

/**
 * The gang this tablet is working for.
 *
 * Persisted per device so it survives a reload, but CLEARED at every session
 * boundary — sign-in and sign-out both — alongside the queue (see
 * useSessionBoundary). A gang is a crew, not a property of the forklift: the
 * next operator to sign in gets their own, rather than inheriting whatever the
 * last shift was filtered to and quietly working the wrong list.
 *
 * It is shown in the top bar on every screen so it can never be a silent
 * setting, and changed from the home screen.
 */

const STORAGE_KEY = 'dockautomation.gang'

const gang = ref<string>(read())

function read(): string {
  if (typeof localStorage === 'undefined') return ''
  try {
    return localStorage.getItem(STORAGE_KEY) ?? ''
  } catch {
    return ''
  }
}

export function useGang() {
  function setGang(name: string) {
    gang.value = name
    try {
      if (name === '') localStorage.removeItem(STORAGE_KEY)
      else localStorage.setItem(STORAGE_KEY, name)
    } catch {
      // Storage unavailable (private mode) — the choice just won't persist.
    }
  }

  return {
    gang: computed(() => gang.value),
    hasGang: computed(() => gang.value !== ''),
    setGang,
    clearGang: () => setGang(''),
  }
}
